import { render, staticRenderFns } from "./MailSegnalazioniDashboard.vue?vue&type=template&id=7f00c002&scoped=true"
import script from "./MailSegnalazioniDashboard.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioniDashboard.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioniDashboard.vue?vue&type=style&index=0&id=7f00c002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f00c002",
  null
  
)

export default component.exports